/*============================================================
   REACT DEPENDENCIES
============================================================*/
import { useState } from "react";

/*============================================================
   REDUX DEPENDENCIES
============================================================*/
import { useSelector, useDispatch } from "react-redux";

import { FormControl } from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormHelperText from "@mui/material/FormHelperText";
import Grid from "@mui/material/Grid2";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import Stack from "@mui/material/Stack";
import TextareaAutosize from "@mui/material/TextareaAutosize";
import Typography from "@mui/material/Typography";

//DATA SLICE - REDUCER
import { updateSummary } from "../../../../states/slcAssetLiability.js";

import GridCheckbox from "../../../widgets/GridCheckbox";
import { valudateTextfield2 } from "../../../../utils/fieldValidator.js";

var isNetworthDisclosedError = "";
var haveNetworthImpactError = "";
var networthImpactDescError = "";

//TRUE - WHEN COMPONENT IS VALID
var validDeclaration = true;

export default function AssetsAndLiabilitiesDeclaration({ setEnableNext }) {
  const declaration = useSelector((state) => state.assetliability);

  const [isNetworthDisclosed, setIsNetworthDisclosed] = useState(declaration.isNetworthDisclosed);
  const [haveNetworthImpact, sethaveNetworthImpact] = useState(declaration.haveNetworthImpact);
  const [networthImpactDesc, setNetworthImpactDesc] = useState(declaration.networthImpactDesc);

  const dispatch = useDispatch();

  //COMPONENT ID
  let id = "";

  function updateRedux(fieldName, fieldValue, reducer) {
    const action = {
      type: fieldName,
      payload: fieldValue,
    };
    dispatch(reducer(action));
  }

  function handleChange(e, object) {
    let input_data = {
      event: e,
      fieldName: "",
      fieldVariable: "",
      isMandatory: false,
    };

    let type = "";
    let name = "";

    id = e.target.id.toLowerCase();

    if (id === "") {
      type = e.target.type;
      name = e.target.name;
      validateRadiobox(e, type, name);
    }

    //CHECKBOX
    validateCheckbox(e, id);

    //TEXTFIELDS
    id = e.target.id;
    validateTextfield(input_data);

    calculateValidity(input_data);
  }

  function validateRadiobox(e, type, name) {
    if (type === "radio" && name === "have-networth-impact") {
      sethaveNetworthImpact(e.target.value);
      updateRedux("haveNetworthImpact", e.target.value, updateSummary);
      haveNetworthImpactError = "";
    }
  }

  function validateCheckbox(e, id) {
    if (id === "isnetworthdisclosed") {
      setIsNetworthDisclosed(e.target.checked);
      updateRedux("isNetworthDisclosed", e.target.checked, updateSummary);
      isNetworthDisclosedError = "";
    }
  }

  function validateTextfield(input_data) {
    if (id === "networthImpactDesc") {
      input_data.fieldName = "Networth impact description";
      input_data.fieldVariable = networthImpactDesc;
      const result = valudateTextfield2(input_data);

      if (result.errorMessage === "") {
        setNetworthImpactDesc(result.value);
        updateRedux("networthImpactDesc", result.value, updateSummary);
      } else networthImpactDescError = result.errorMessage;
    }
  }

  function calculateValidity() {
    validDeclaration = false;

    if (haveNetworthImpact.length === 0) {
      haveNetworthImpactError = "Networth impact is required";
      setEnableNext(false);
      return;
    }

    console.log("haveNetworthImpact = " + haveNetworthImpact);

    if (haveNetworthImpact === "YES") {
      if (networthImpactDesc.length === 0) {
        networthImpactDescError = "Networth impact description required";
        setEnableNext(false);
        return;
      }
    }

    validDeclaration = true;
    setEnableNext(true);
  }

  return (
    <>
      {/* DECLARATION: DO NOT WISH TO DISCLOSE CASH FLOW INFORMATION */}
      <Typography variant="body1" gutterBottom sx={{ p: 2, my: 1, border: "1px solid", borderRadius: 5 }}>
        <GridCheckbox
          id="isNetworthDisclosed"
          columnSize="12"
          required
          label="I do not wish to fully diclose my assets & liabilities."
          disabled={false}
          checked={isNetworthDisclosed}
          onChange={handleChange}
        />
      </Typography>
      <Grid size={12}>
        <Typography variant="body1">
          Are there any factors within the next 12 months which may significantly increase / decrease your current
          networth?
        </Typography>

        <RadioGroup row name="have-networth-impact" defaultValue="" value={haveNetworthImpact} onChange={handleChange}>
          <FormControl>
            <Stack direction="row">
              <FormControlLabel id="networthImpactYes" value="YES" control={<Radio />} label="Yes" />

              <FormControlLabel id="networthImpactNo" value="NO" control={<Radio />} label="No" />
            </Stack>

            {haveNetworthImpactError && (
              <FormHelperText error={haveNetworthImpactError}>{haveNetworthImpactError}</FormHelperText>
            )}
          </FormControl>
        </RadioGroup>

        {(haveNetworthImpact === "YES" || haveNetworthImpact === "") && (
          <TextareaAutosize
            id="networthImpactDesc"
            placeholder="Type here..."
            style={{ width: "100%" }}
            minRows={5}
            onChange={handleChange}
            defaultValue={networthImpactDesc}
          />
        )}
      </Grid>
    </>
  );
}
